module.exports = __webpack_public_path__ + "static/media/setIconActive.ffcd4e28.svg";